import { render, staticRenderFns } from "./LeadsCardVehicleMake.vue?vue&type=template&id=7108ba99&scoped=true&"
import script from "./LeadsCardVehicleMake.vue?vue&type=script&lang=js&"
export * from "./LeadsCardVehicleMake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7108ba99",
  null
  
)

export default component.exports